import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

interface DealershipsState {
    fetching: FetchingTypes;
    dealerships: any[];
    dealershipsInfo: any[];
    dealershipsInfoURL: any[];
    brandDealershipsInfo: any[];
    total: number;
    found: boolean;
}

const initialState: DealershipsState = {
    fetching: "unknown",
    dealerships: [],
    dealershipsInfo: [],
    dealershipsInfoURL: [],
    brandDealershipsInfo: [],
    total: 0,
    found: false
};

const dealershipsSlice = createSlice({
    name: "dealerships",
    initialState,
    reducers: {
        getDealershipsRequest: (state) => {
            state.fetching = "loading";
        },
        getDealershipsSuccess: (state, action) => {
            state.fetching = "success";
            state.dealerships = action.payload.dealerships;
            state.total = action.payload.total;
            state.found = action.payload.found;
        },
        getDealershipsFailure: (state) => {
            state.fetching = "failure";
            state.dealerships = [];
        },
        getInfoDealershipsRequest: (state) => {
            state.fetching = "loading";
        },
        getInfoDealershipsSuccess: (state, action) => {
            state.fetching = "success";
            state.dealershipsInfo = action.payload;
        },
        getInfoDealershipsFailure: (state) => {
            state.fetching = "failure";
            state.dealershipsInfoURL = [];
        },
        getDealershipsURLRequest: (state) => {
            state.fetching = "loading";
        },
        getDealershipsURLSuccess: (state, action) => {
            state.fetching = "success";
            state.dealershipsInfoURL = action.payload;
        },
        getDealershipsURLFailure: (state) => {
            state.fetching = "failure";
            state.dealershipsInfoURL = [];
        },
        getBrandsDealershipsRequest: (state) => {
            state.fetching = "loading";
        },
        getBrandsDealershipsSuccess: (state, action) => {
            state.fetching = "success";
            state.brandDealershipsInfo = action.payload;
        },
        getBrandsDealershipsFailure: (state) => {
            state.fetching = "failure";
            state.brandDealershipsInfo = [];
        },
        cleanDealerships: () => initialState
    }
});

export const {
    getDealershipsRequest,
    getDealershipsSuccess,
    getDealershipsFailure,
    cleanDealerships,
    getInfoDealershipsRequest,
    getInfoDealershipsSuccess,
    getInfoDealershipsFailure,
    getDealershipsURLRequest,
    getDealershipsURLSuccess,
    getDealershipsURLFailure,
    getBrandsDealershipsRequest,
    getBrandsDealershipsSuccess,
    getBrandsDealershipsFailure
} = dealershipsSlice.actions;

export default dealershipsSlice.reducer;